module.exports = function isBoolean(x) {
  return x === true || x === false;
};


//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/tcomb/lib/isBoolean.js
// module id = 417
// module chunks = 69